import { asyncThunkWrapper } from "../thunkHandler";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BASEURI, headers } from "../../utils/helper";

// Retrieve all specialists
export const handleRetrieveAllSpecialists = createAsyncThunk(
	"retrieveAll",
	async (data, thunkAPI) => {
		const params = {
			limit: data?.limit || null,
			search: data?.search || null,
			currentPage: data?.currentPage || null,
			specializationId: data?.specializationId || null,
			minPrice: data?.minPrice || null,
			maxPrice: data?.maxPrice || null,
			experience: data?.experience || null,
			language: data?.language || null,
		};

		return asyncThunkWrapper(
			{
				params,
				method: "GET",
				headers: headers(),
				url: `${BASEURI}/member/specialist/retrieve-all`,
			},
			thunkAPI,
			{
				toast: false,
			}
		);
	}
);



// Retrieve specialist details 
export const handleRetrieveSpecialistDetails = createAsyncThunk(
	"retrieveSingle",
	async (data, thunkAPI) => {
		const specialistId = data?.specialistId;
		const timeZone =
			data?.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
		const params = {
			memberId: data?.memberId || "pending",
			limit: data?.limit || 10,
			currentPage: data?.currentPage || null,
			date: data?.date || null,
			status: data?.status || null,
			timeZone
		};
		return asyncThunkWrapper(
			{
				params,
				method: "GET",
				headers: headers(),
				url: `${BASEURI}/member/specialist/retrieve/details/${specialistId}?timeZone=${timeZone}`,
			},
			thunkAPI,
			{
				toast: false,
			}
		);
	}
);
